import React from "react";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import PanelEmptyStateApp from "../Functionality/PanelEmptyStateApp";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Empty state of the canvas and of the unconfigured panels: illustration, legend and call to action.
 *
 * @param {string} legend - Translation key of the legend.
 * @param {string} action - Translation key of the call to action.
 * @param {Function} onAction - Click of the call to action.
 * @param {boolean} add - Uses the "add" illustration of the empty canvas.
 */
const PanelEmptyState = ({ legend, action, onAction, add = false }) => {
    const { t, Illustration } = PanelEmptyStateApp({ add });

    return (
        <div className='event-monitoring-panel-empty-state custom-scrollbar d-flex flex-column justify-content-center align-items-center gap-2 p-2'>
            <Illustration className='event-monitoring-panel-empty-state-illustration w-90px' />
            <div className='event-monitoring-panel-empty-state-legend d-flex flex-column align-items-center w-100 text-center'>
                <p className='fs-14px ibl-font-w-400 font-color-general-950'>{t(legend)}</p>
                {action &&
                    <CustomButtonLink
                        id={`btn_pes_${action}`}
                        name={action}
                        splitName={false}
                        className='fs-14px'
                        onClick={onAction}
                    />
                }
            </div>
        </div>
    );
};

export default PanelEmptyState;
